import React from "react";
import { LANDING } from "../constants/testIds/landing";
import { Mail, Calendar, MapPin, Sparkles } from "lucide-react";

export const PrivateClasses = ({ t }) => {
  return (
    <section
      id="contact"
      className="py-24 sm:py-32 lg:py-40 bg-[#efe7dd] text-[#1c110e] border-t border-[#b58e70]/20 overflow-hidden relative"
    >
      {/* Background elegant gradient elements */}
      <div className="absolute left-0 bottom-0 w-[400px] h-[400px] rounded-full bg-[#d97036]/5 blur-[100px] pointer-events-none z-0" />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        
        {/* Asymmetric Split Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {/* Left: Interactive Details & Perks */}
          <div className="lg:col-span-7 space-y-8">
            <div className="space-y-4">
              <span className="font-sans text-xs sm:text-sm tracking-[0.3em] uppercase text-[#d97036] font-medium block">
                {t.privateClasses.title}
              </span>
              <h2
                data-testid={LANDING.contactTitle}
                className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1c110e] tracking-tight font-light leading-tight"
              >
                {t.privateClasses.subtitle}
              </h2>
              <div className="h-[1px] w-24 bg-[#8a2424] mt-6" />
            </div>

            <div className="space-y-6 font-sans text-sm sm:text-base text-[#5a4b46] leading-relaxed font-light">
              <p>{t.privateClasses.description1}</p>
              <p>{t.privateClasses.description2}</p>
            </div>

            {/* Structured perks/features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
              <div className="flex items-center space-x-4 p-4 bg-[#e5d8cb] border border-[#b58e70]/20">
                <Calendar className="w-5 h-5 text-[#d97036] shrink-0" />
                <span className="font-sans text-xs sm:text-sm text-[#1c110e] font-light">
                  {t.privateClasses.perkScheduling}
                </span>
              </div>
              <div className="flex items-center space-x-4 p-4 bg-[#e5d8cb] border border-[#b58e70]/20">
                <MapPin className="w-5 h-5 text-[#d97036] shrink-0" />
                <span className="font-sans text-xs sm:text-sm text-[#1c110e] font-light">
                  {t.privateClasses.perkLocation}
                </span>
              </div>
              <div className="flex items-center space-x-4 p-4 bg-[#e5d8cb] border border-[#b58e70]/20">
                <Sparkles className="w-5 h-5 text-[#d97036] shrink-0" />
                <span className="font-sans text-xs sm:text-sm text-[#1c110e] font-light">
                  {t.privateClasses.perkInstructors}
                </span>
              </div>
              <div className="flex items-center space-x-4 p-4 bg-[#e5d8cb] border border-[#b58e70]/20">
                <Mail className="w-5 h-5 text-[#d97036] shrink-0" />
                <span className="font-sans text-xs sm:text-sm text-[#1c110e] font-light">
                  {t.privateClasses.perkEmail}
                </span>
              </div>
            </div>
          </div>

          {/* Right: Direct Email Booking Card */}
          <div className="lg:col-span-5">
            <div className="relative group">
              {/* Outer light brown border glow */}
              <div className="absolute -inset-1 bg-gradient-to-tr from-[#d97036] to-[#8a2424] opacity-20 blur-sm group-hover:opacity-30 transition-opacity duration-500" />
              
              <div className="relative bg-[#e5d8cb] border border-[#b58e70]/30 p-8 sm:p-12 text-center flex flex-col items-center justify-center space-y-8 shadow-xl">
                
                <div className="w-16 h-16 bg-[#8a2424]/10 border border-[#b58e70]/30 flex items-center justify-center mb-2">
                  <Mail className="w-6 h-6 text-[#d97036]" />
                </div>

                <div className="space-y-3">
                  <h4 className="font-serif text-2xl text-[#1c110e] font-light tracking-tight">
                    {t.privateClasses.cardTitle}
                  </h4>
                  <p className="font-sans text-xs sm:text-sm text-[#5a4b46] leading-relaxed font-light">
                    {t.privateClasses.cardText}
                  </p>
                </div>

                {/* Direct Mailto Button (as requested by user) */}
                <a
                  href="mailto:office@entreamigos.at?subject=Anfrage Privatstunden Tango Argentino"
                  data-testid={LANDING.contactEmailLink}
                  className="w-full bg-[#8a2424] text-[#f7f2ed] hover:bg-[#a32e2e] transition-colors duration-300 py-4 uppercase tracking-[0.2em] text-xs font-semibold border border-[#8a2424] hover:border-[#a32e2e]"
                >
                  {t.privateClasses.cta}
                </a>

                <p className="font-mono text-xs text-[#8a2424] tracking-wider">
                  office@entreamigos.at
                </p>

              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};
